"use client";

import React from "react";
import MainNav from "../navigation/main-nav";
import MobileNav from "../navigation/mobile-nav";
import {
  GetStartedLink,
  SignInLink
} from "app/_components/layout/Header/HeaderLink";
import { useTranslations } from "i18n";

function GetStartedButton() {
  const t = useTranslations("common");
  return <GetStartedLink label={t("getStarted")} />;
}

function SignInButton() {
  const t = useTranslations("common");
  return <SignInLink label={t("signIn")} size="md" />;
}

function MobileGetStartedButton() {
  const t = useTranslations("common");
  return (
    <GetStartedLink className="flex-grow" label={t("getStarted")} size="lg" />
  );
}

function MobileSignInButton() {
  const t = useTranslations("common");
  return <SignInLink className="flex-grow" label={t("signIn")} size="lg" />;
}

const Header = () => {
  return (
    <header id="global-header" className="sticky top-0 z-[100] h-[60px]">
      <MainNav
        rightItems={
          <React.Fragment>
            <SignInButton />
            <GetStartedButton />
          </React.Fragment>
        }
      />
      <MobileNav
        navItems={<GetStartedButton />}
        bottomItems={
          <React.Fragment>
            <MobileSignInButton />
            <MobileGetStartedButton />
          </React.Fragment>
        }
      />
    </header>
  );
};

export default Header;
